import React from 'react'

import { useTranslation } from 'react-i18next'
import { FieldProps } from '../../../../../../../@types/types'
import { OtherFacilitiesScreenValidationResult } from '../../../../../../../@types/validation-types'
import TextInput from '../../../../../../common/inputs/textInput/TextInput'
import { getDefaultClasses } from '../../../../../../../utils/style-utils'

const WidthGarageField: React.FC<FieldProps<OtherFacilitiesScreenValidationResult>> = ({
  screenName,
  insertionData,
  validationMessages,
  onChange,
}) => {
  const { t } = useTranslation()
  return (
    <div className={getDefaultClasses('left')}>
      <TextInput
        id='width-garage'
        propertyName='widthGarage'
        placeholder=''
        label={<span>{t('wizard.screen.otherFacilities.widthGarage', 'Width of Garage')}</span>}
        value={insertionData.widthGarage}
        maxLength={5}
        type='text'
        affixRight='unit'
        unitRight='meters'
        errors={validationMessages?.widthGarage ?? []}
        doOnFieldChange={(property, value) => onChange({ screen: screenName, property }, value)}
      />
    </div>
  )
}

export default WidthGarageField
